import gsap from "gsap"
import { Observer } from "gsap/Observer"
import { ScrollTrigger } from "gsap/ScrollTrigger"

// Register GSAP plugins with SSR compatibility
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger, Observer)
}

export { gsap, Observer, ScrollTrigger }
